import { useCallback, useEffect, useState } from 'react';
import type { DonViTinh, GiaMuaVatTuData, VatTu } from '@/types/schemas';

type Params = {
  vatTu: VatTu | null;
  setVatTu: (vatTu: VatTu | null) => void;
  donViTinh: DonViTinh | null;
  setDonViTinh: (donViTinh: DonViTinh | null) => void;
};

const useVatTuDvtOptions = ({ vatTu, setVatTu, donViTinh, setDonViTinh }: Params) => {
  const [dvtOptions, setDvtOptions] = useState<DonViTinh[]>([]);

  const buildDvtOptions = useCallback(
    (selectedVatTu: GiaMuaVatTuData) => {
      const options = [
        ...(selectedVatTu?.dvt_data ? [selectedVatTu.dvt_data] : []),
        ...(selectedVatTu.quy_doi_dvt_data || []).flatMap(item => (item.dvt_data ? [item.dvt_data] : []))
      ];

      const uniqueOptions = options.filter(
        (option, index, self) => self.findIndex(item => item?.uuid === option?.uuid) === index
      );

      setDvtOptions(uniqueOptions);

      const matched = uniqueOptions.find(option => option.uuid === donViTinh?.uuid);
      if (!matched) {
        setDonViTinh(uniqueOptions[0] || null);
      }
    },
    [donViTinh?.uuid, setDonViTinh]
  );

  const handleVatTuSelection = useCallback(
    (selectedVatTu: VatTu | null) => {
      if (!selectedVatTu) {
        setVatTu(null);
        setDonViTinh(null);
        setDvtOptions([]);
        return;
      }

      setVatTu(selectedVatTu);
      buildDvtOptions(selectedVatTu);
    },
    [buildDvtOptions, setDonViTinh, setVatTu]
  );

  useEffect(() => {
    if (!vatTu) {
      setDvtOptions([]);
      return;
    }

    buildDvtOptions(vatTu);
  }, [vatTu, buildDvtOptions]);

  return {
    dvtOptions,
    handleVatTuSelection
  };
};

export default useVatTuDvtOptions;
